import SelectStyled from "@/components/SelectStyled";
import { MenuItem } from "@mui/material";

const TimeHourSelector = ({defaultValue, onChange, ...props}) => {

  const handleInputChanged = (event, value = null) => {
    if (onChange) {
      onChange(event, value);
    }
  };

  const hours = () => {
    let allHours = [];
    for (let h = 0; h <= 24; h++) {
      allHours = [...allHours, h];
    }

    return allHours;
  };


  return (
    <SelectStyled
      values={hours()}
      value={defaultValue}
      onChange={handleInputChanged}
      menuProps="LimitHeight"
      allowEmpty={true}
    >
      {hours().map((option, idx) => (
        <MenuItem value={option} key={idx}>
          {option}
        </MenuItem>
      ))}
    </SelectStyled>
  );
};

export default TimeHourSelector;
